import * as THREE from 'three';
import { GAME_CONFIG } from './config';

export type ThrowSolution = {
  velocity: THREE.Vector3;
  flightTime: number;
};

const GRAVITY = 9.81;
const PHYSICS_TIMESTEP = 1 / 60;
// Rapier advances velocity before position at 60 Hz. Half a gravity step keeps
// the collision-free preview aligned with that semi-implicit integration.
const SEMI_IMPLICIT_COMPENSATION = GRAVITY / 120;

export function solveThrow(
  start: THREE.Vector3,
  target: THREE.Vector3,
  power: number,
  result: ThrowSolution = { velocity: new THREE.Vector3(), flightTime: 1 },
): ThrowSolution {
  const clampedPower = THREE.MathUtils.clamp(power, 0, 1);
  const easedPower = THREE.MathUtils.smoothstep(clampedPower, 0, 1);
  const flightTime = THREE.MathUtils.lerp(
    GAME_CONFIG.maxFlightTime,
    GAME_CONFIG.minFlightTime,
    easedPower,
  );

  result.flightTime = flightTime;
  result.velocity.copy(target).sub(start).divideScalar(flightTime);
  result.velocity.y =
    (target.y - start.y + 0.5 * GRAVITY * flightTime * flightTime) / flightTime +
    SEMI_IMPLICIT_COMPENSATION;
  return result;
}

export function sampleThrow(
  start: THREE.Vector3,
  velocity: THREE.Vector3,
  time: number,
  target: THREE.Vector3,
): THREE.Vector3 {
  target.copy(start).addScaledVector(velocity, time);
  target.y -=
    0.5 * GRAVITY * time * time +
    0.5 * GRAVITY * PHYSICS_TIMESTEP * time;
  return target;
}
